// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/ic-youtube.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/newsSocial.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.module-news-slide-img {
  display: block;
  min-height: 265px;
  min-width: 517px;
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}
.module-news-slide-frame {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center, rgba(0, 0, 0, 0.12);
  background-size: 88px;
}
.module-news-slide-wrapper {
  position: relative;
  width: 517px;
  margin: 0 auto;
  overflow: hidden;
}
.module-news-slide-list {
  position: relative;
  left: 0;
}
.module-news-slide-title {
  position: absolute;
  width: 100%;
  text-align: center;
  font-weight: 600;
  margin-top: 8px;
}
.module-news-slide-title a {
  color: #8BC34A;
}
.module-news-slide-share {
  position: absolute;
  top: 32px;
  right: 16px;
  cursor: pointer;
}
.module-news-slide-share-img {
  width: 20px;
  height: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  float: left;
  margin-left: 16px;
}
.module-news-slide-share-inst {
  background-position: 0 -21px;
}
.module-news-slide-share-inst:hover {
  cursor: pointer;
  background-position: 0 0;
}
.module-news-slide-share-facebook {
  background-position: -32px -21px;
}
.module-news-slide-share-facebook:hover {
  cursor: pointer;
  background-position: -32px 0;
}
.module-news-slide-share-twitter {
  background-position: -58px -21px;
}
.module-news-slide-share-twitter:hover {
  cursor: pointer;
  background-position: -58px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewsSlider/less/slide.less"],"names":[],"mappings":"AAIC;EACC,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,wBAAA;EACA,4BAAA;AAHF;AAMC;EACC,yFAAA;EACA,qBAAA;AAJF;AAOC;EACC,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AALF;AAQC;EACC,kBAAA;EACA,OAAA;AANF;AASC;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAPF;AAEC;EAQE,cAAA;AAPH;AAWC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AATF;AAWE;EACC,WAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,iBAAA;AATH;AAYE;EACC,4BAAA;AAVH;AAYG;EACC,eAAA;EACA,wBAAA;AAVJ;AAcE;EACC,gCAAA;AAZH;AAaG;EACC,eAAA;EACA,4BAAA;AAXJ;AAeE;EACC,gCAAA;AAbH;AAcG;EACC,eAAA;EACA,4BAAA;AAZJ","sourcesContent":["@import (reference) \"../../../less/variables\";\n@import (reference) \"../../../less/mixins\";\n\n.module-news-slide {\n\t&-img {\n\t\tdisplay: block;\n\t\tmin-height: 265px;\n\t\tmin-width: 517px;\n\t\tbackground-position: 50% 50%;\n\t\tbackground-size: contain;\n\t\tbackground-repeat: no-repeat;\n\t}\n\n\t&-frame {\n\t\tbackground: url(../img/ic-youtube.svg) no-repeat center, rgba(0, 0, 0, 0.12);\n\t\tbackground-size: @gutter*11;\n\t}\n\n\t&-wrapper {\n\t\tposition: relative;\n\t\twidth: 517px;\n\t\tmargin: 0 auto;\n\t\toverflow: hidden;\n\t}\n\n\t&-list {\n\t\tposition: relative;\n\t\tleft: 0;\n\t}\n\n\t&-title {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tfont-weight: @twSemi;\n\t\tmargin-top: @gutter;\n\n\t\ta {\n\t\t\tcolor: @tAccent;\n\t\t}\n\t}\n\n\t&-share {\n\t\tposition: absolute;\n\t\ttop: @gutter*4;\n\t\tright: @gutter*2;\n\t\tcursor: pointer;\n\n\t\t&-img {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tbackground: url(\"../img/newsSocial.png\") no-repeat;\n\t\t\tfloat: left;\n\t\t\tmargin-left: @gutter*2;\n\t\t}\n\n\t\t&-inst {\n\t\t\tbackground-position: 0 -21px;\n\n\t\t\t&:hover {\n\t\t\t\tcursor: pointer;\n\t\t\t\tbackground-position: 0 0\n\t\t\t}\n\t\t}\n\n\t\t&-facebook {\n\t\t\tbackground-position: -32px -21px;\n\t\t\t&:hover {\n\t\t\t\tcursor: pointer;\n\t\t\t\tbackground-position: -32px 0;\n\t\t\t}\n\t\t}\n\n\t\t&-twitter {\n\t\t\tbackground-position: -58px -21px;\n\t\t\t&:hover {\n\t\t\t\tcursor: pointer;\n\t\t\t\tbackground-position: -58px 0;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
